import axios from "axios"

export default function updatePointCut({
    id,
    amount,
    parentId,
    status,
    itemId,
    startAt,
    endAt
}) {
    return new Promise((resolve, reject) => {
        axios.put(`/campaign/api/admin/items-setting/${id}`,
            {
                amount,
                parentId,
                status,
                itemId,
                startAt,
                endAt
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}